export default "__VITE_ASSET__ufRkoXWk__"